import React, { useState, useEffect, useLayoutEffect, useRef, memo } from "react";
import { useLocation } from "react-router-dom";
import {
  CategoryButton,
  SubMenuItem,
  SubMenuPanel,
  SubMenuPanelItem,
  MenuLink,
  ScrollContainer,
  Layout,
  Content,
} from "./MainMenuBar.style";

import FW from "../../../../../config/word.json";

const MENU_SCROLL_POSITION_KEY = "menuBarScrollLeft";

// メニュー定義
export const homeBar = [
  {
    title: FW.F_W_SYS_HOME,
    path: "/home",
    icon: <img src="/images/icons/home_active.svg" alt="" />,
    clickedIcon: <img src="/images/icons/home.svg" alt="" />,
  },
];

export const logOutBar = [
  {
    title: FW.F_W_SYS_LOGOUT,
    path: "/",
    icon: <img src="/images/icons/log-out-active.svg" alt="" />,
    clickedIcon: <img src="/images/icons/log-out.svg" alt="" />,
  },
];

export const approvalGroupBar = [
  {
    title: FW.F_W_HOME_ApprovalList,
    path: "/approvallist",
    icon: (
      <span role="img" aria-label="承認待ち" style={{ fontSize: "20px" }}>
        ⏳
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="承認待ち" style={{ fontSize: "20px" }}>
        ⏳
      </span>
    ),
  },
  {
    title: FW.F_W_HOME_ApprovaledList,
    path: "/approvaledlist",
    icon: (
      <span role="img" aria-label="承認済み" style={{ fontSize: "20px" }}>
        ✅
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="承認済み" style={{ fontSize: "20px" }}>
        ✅
      </span>
    ),
  },
  {
    title: FW.F_W_HOME_RejectList,
    path: "/rejectedlist",
    icon: (
      <span role="img" aria-label="否認" style={{ fontSize: "20px" }}>
        ❌
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="否認" style={{ fontSize: "20px" }}>
        ❌
      </span>
    ),
  },
];
// 基本ボタン
export const menuGroupBar = [
  {
    title: FW.F_W_SYS_HOME,
    path: "/home",
    icon: (
      <img
        src="/images/icons/home_active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/home.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
  {
    title: FW.F_W_SYS_LOGOUT,
    path: "/",
    icon: (
      <img
        src="/images/icons/log-out-active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/log-out.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
];

export const fansGroupBar = [
  {
    title: FW.F_W_HOME_JOIN,
    path: "/joinInfo",
    icon: (
      <img
        src="/images/icons/user.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/user_active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
  {
    title: "大会管理",
    path: "/daikaiManage",
    icon: (
      <img
        src="/images/icons/calendar-alt.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/calendar-alt-active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
  {
    title: FW.F_W_HOME_FAN,
    path: "/fans",
    icon: (
      <img
        src="/images/icons/fans.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/fans_active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
  {
    title: FW.F_W_HOME_FANCOUNT,
    path: "/countFans",
    icon: (
      <img
        src="/images/icons/count.svg"
        alt=""
        color="#cccccc"
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/count_active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
];

// ゲスト用
export const fansGroupBarForGuest_8 = [
  {
    title: FW.F_W_HOME_JOIN,
    path: "/joinInfoForGuest",
    icon: (
      <img
        src="/images/icons/user.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/user_active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
];

// 広告
export const adGroupBar = [
  {
    title: "統計",
    path: "/adDisplayInfo",
    icon: (
      <span role="img" aria-label="統計" style={{ fontSize: "20px" }}>
        🎯
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="統計" style={{ fontSize: "20px" }}>
        🎯
      </span>
    ),
  },
  {
    title: "広告一覧",
    path: "/adList",
    icon: (
      <span role="img" aria-label="広告一覧" style={{ fontSize: "20px" }}>
        📋
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="広告一覧" style={{ fontSize: "20px" }}>
        📋
      </span>
    ),
  },
];

// バナー
export const bannerGroupBar = [
  {
    title: "大バナー",
    path: "/bannerManage",
    icon: (
      <span role="img" aria-label="大バナー" style={{ fontSize: "20px" }}>
        🖼️
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="大バナー" style={{ fontSize: "20px" }}>
        大
      </span>
    ),
  },
  {
    title: "小バナー",
    path: "/smallBannerManage",
    icon: (
      <span role="img" aria-label="小バナー" style={{ fontSize: "20px" }}>
        🧑‍🤝‍🧑
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="小バナー" style={{ fontSize: "20px" }}>
        小
      </span>
    ),
  },
];

// データ移行
export const sysGroupBar = [
  {
    title: "データ移行",
    path: "/dataIko",
    icon: (
      <span role="img" aria-label="データ移行" style={{ fontSize: "20px" }}>
        🔄
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="データ移行" style={{ fontSize: "20px" }}>
        🔄
      </span>
    ),
  },
];

// ゲスト用
export const adGroupBar_7 = [
  {
    title: "統計",
    path: "/dashboard",
    icon: (
      <span role="img" aria-label="統計" style={{ fontSize: "20px" }}>
        🎯
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="統計" style={{ fontSize: "20px" }}>
        🎯
      </span>
    ),
  },
];

// 子リンクコンポーネント
const CustomMenuLink = ({
  title,
  to,
  icon,
  clickedIcon,
  activePath,
  onClick,
}) => {
  const url = useLocation().pathname;
  const isActive =
    to !== "/" &&
    (activePath === to || url === to || url.startsWith(`${to}/`));
  const onClickMenuItem = (toPage) => () => {
    if (toPage === "/") {
      sessionStorage.clear();
    } else {
      onClick?.();
    }
  };
  return (
    <SubMenuPanelItem $active={isActive}>
      <MenuLink
        to={to}
        onClick={onClickMenuItem(to)}
        aria-current={isActive ? "page" : undefined}
      >
        <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {isActive ? icon : clickedIcon}
          <span>{title}</span>
        </span>
      </MenuLink>
    </SubMenuPanelItem>
  );
};

function MenuBar() {
  const location = useLocation();
  const scrollContainerRef = useRef(null);

  // 一つだけ開くメニューのキーをstateで管理
  const [openKey, setOpenKey] = useState(() => {
    const saved = sessionStorage.getItem("openKey");
    return saved || null;
  });

  // クリック中の子メニューのpathをstateで管理（初期値は現在のURLパス）
  const [activePath, setActivePath] = useState(location.pathname);

  // URL変化があればactivePathも更新
  useEffect(() => {
    setActivePath(location.pathname);
  }, [location.pathname]);

  // openKey を sessionStorage に保存
  useEffect(() => {
    if (openKey) {
      sessionStorage.setItem("openKey", openKey);
    } else {
      sessionStorage.removeItem("openKey");
    }
  }, [openKey]);

  // ページ遷移でMenuBarが再生成されても、親メニューのスクロール位置を維持する
  useLayoutEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) {
      return undefined;
    }

    const savedScrollLeft = Number(
      sessionStorage.getItem(MENU_SCROLL_POSITION_KEY)
    );
    if (Number.isFinite(savedScrollLeft)) {
      scrollContainer.scrollLeft = savedScrollLeft;
    }

    const saveScrollPosition = () => {
      sessionStorage.setItem(
        MENU_SCROLL_POSITION_KEY,
        String(scrollContainer.scrollLeft)
      );
    };

    scrollContainer.addEventListener("scroll", saveScrollPosition, {
      passive: true,
    });

    return () => {
      // ログアウト時はセッションがクリア済みなので位置を保存しない
      if (sessionStorage.getItem("userId")) {
        saveScrollPosition();
      }
      scrollContainer.removeEventListener("scroll", saveScrollPosition);
    };
  }, []);

  const saveCurrentScrollPosition = () => {
    if (scrollContainerRef.current) {
      sessionStorage.setItem(
        MENU_SCROLL_POSITION_KEY,
        String(scrollContainerRef.current.scrollLeft)
      );
    }
  };

  // メニューの開閉切替
  const toggleOpen = (key) => {
    setOpenKey((prev) => (prev === key ? null : key));
  };

  const userFlg = sessionStorage.getItem("userFlg");
  const menuCategories = [
    {
      key: "base",
      title: "≡基本",
      items: menuGroupBar,
    },
    ...(userFlg === "9"
      ? [
          {
            key: "approval",
            title: "✅承認フロー",
            items: approvalGroupBar,
          },
          {
            key: "fans",
            title: "❤️ファン",
            items: fansGroupBar,
          },
          {
            key: "ad",
            title: "📢広告",
            items: adGroupBar,
          },
          {
            key: "banner",
            title: "🖼️バナー",
            items: bannerGroupBar,
          },
          {
            key: "sys",
            title: "⚙️システム",
            items: sysGroupBar,
          },
        ]
      : []),
    ...(userFlg === "8"
      ? [
          {
            key: "fans",
            title: "❤️ファン",
            items: fansGroupBarForGuest_8,
          },
        ]
      : []),
    ...(userFlg === "7"
      ? [
          {
            key: "ad",
            title: "📢広告",
            items: adGroupBar_7,
          },
        ]
      : []),
  ];
  const openCategory = menuCategories.find(
    (category) => category.key === openKey
  );

  return (
    <Layout onPointerDownCapture={saveCurrentScrollPosition}>
      <Content>
        {openCategory && (
          <SubMenuPanel aria-label={`${openCategory.title} サブメニュー`}>
            {openCategory.items.map((item) => (
              <CustomMenuLink
                key={item.title}
                title={item.title}
                to={item.path}
                icon={item.icon}
                clickedIcon={item.clickedIcon}
                activePath={activePath}
                onClick={() => setActivePath(item.path)}
              />
            ))}
          </SubMenuPanel>
        )}

        <ScrollContainer ref={scrollContainerRef}>
          {menuCategories.map((category) => {
            const isOpen = openKey === category.key;
            return (
              <SubMenuItem key={category.key}>
                <CategoryButton
                  type="button"
                  $active={isOpen}
                  aria-expanded={isOpen}
                  onClick={() => toggleOpen(category.key)}
                >
                  {category.title}
                </CategoryButton>
              </SubMenuItem>
            );
          })}
        </ScrollContainer>
      </Content>
    </Layout>
  );
}

export default memo(MenuBar);
